export default "__VITE_ASSET__2epiwfSa__"